import { useContext } from 'react'
import { Grid, TablePagination, Typography, Link } from "@material-ui/core"
import { appUserContext } from "helpers/services";
import { ticketsContext } from 'views/Tickets/TicketsContext';
import { BulkEdit } from 'components';

let ToolBar = () => {
    let { currentUser } = useContext(appUserContext);
    let { selectedItems, recordCount, search, selectAllPages, selectAll, changePage } = useContext(ticketsContext);


    return (
        <Grid container alignItems="center">
            <Grid item xs>
                {selectedItems.length > 0 &&
                    <Grid container spacing={0} alignItems="flex-end">
                        <Grid item>
                            <Typography>{selectAllPages ? recordCount : selectedItems.length} selected claims</Typography>
                        </Grid>
                        {Math.ceil(recordCount / search.pageSize) > 1 &&
                            <Grid item>
                                <Link component="button" variant="body2" onClick={selectAll}>{selectAllPages ? 'Clear selection' : 'Select all pages'}</Link>
                            </Grid>
                        }
                    </Grid>
                }
            </Grid>
            {selectedItems.length > 0 && currentUser?.canDoBulkEdit &&
                <Grid item>
                    <BulkEdit
                        numberOfItems={recordCount}
                        selectAllPages={selectAllPages}
                        selectedItems={selectedItems}
                        search={search}
                    />
                </Grid>
            }
            <Grid item>
                <TablePagination
                    rowsPerPageOptions={[search.pageSize]}
                    component="div"
                    count={recordCount}
                    rowsPerPage={search.pageSize}
                    page={search.pageNr}
                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                    onPageChange={(e, page) => changePage(page)}
                    labelDisplayedRows={({ page }) =>
                        <>Found {recordCount} tickets&nbsp;&middot;&nbsp;page {page + 1} of {Math.ceil(recordCount / search.pageSize)}</>
                    }
                />
            </Grid>
        </Grid>
    )
}

export default ToolBar;